import { render } from "./MyVideos.vue?vue&type=template&id=950b4f92&scoped=true"
import script from "./MyVideos.vue?vue&type=script&lang=js"
export * from "./MyVideos.vue?vue&type=script&lang=js"

import "./MyVideos.vue?vue&type=style&index=0&id=950b4f92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-950b4f92"]])

export default __exports__